
import { defineComponent, onMounted, computed, ref,createVNode } from "vue";
import { useLogout, useUserLoginInfo } from "@/script/auth/authScript";
import { useStore } from "@/store";
import { useRouter } from "vue-router";
import {  Modal } from "ant-design-vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";

export default defineComponent({
  name: "HeaderMobileView",
  components: {
  },

  setup() {
    const store = useStore();
    const router = useRouter();

    const useIsLogin = computed(() => store.state.auth.isLogin);
    const userName = computed(() => store.state.auth.name?store.state.auth.name:"");

    const { logout } = useLogout(store);


    const mobileLogout = () => {
      Modal.confirm({
        title: "홈페이지로 이동 하시겠습니까?  (세션이 종료됩니다.)",
        icon: createVNode(ExclamationCircleOutlined),
        cancelText: "취소",
        okText: "확인",
        wrapClassName: "confirm-modal",
        onOk() {
          logout();
        },
      });
    };

    return {
      useIsLogin,
      userName,
      router,
      mobileLogout,
    };
  },
});
